import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-taskflow-host',
  templateUrl: './taskflow-host.component.html',
  styleUrls: ['./taskflow-host.component.scss']
})
export class TaskflowHostComponent { }
